"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _excluded = ["classNames", "children", "Component", "className", "viewBox", "style"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.svgIcon || defaultStyle : _props$classNames,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== additionalStyles.svgIcon) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(Component, {
    ref: ref,
    className: (0, _clsx["default"])(classNames.root, className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: viewBox
  }, rest, {
    className: classNames.svg
  }), children));
});